import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { DynamicInvoiceTemplateService } from './dynamic-invoice-template.service';
import { CommonService } from '../../services/common.service';
import { fadeInOut } from '../../services/app.animation';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AdhocPaymentOptionsComponent } from 'src/app/adhoc-invoice/adhoc-payment-options/adhoc-payment-options.component';
import { AdhocInvoiceService } from 'src/app/adhoc-invoice/shared/adhoc-invoice.service';

@Component({
  selector: 'app-dynamic-invoice-template',
  templateUrl: './dynamic-invoice-template.component.html',
  styleUrls: ['./dynamic-invoice-template.component.scss'],
  animations: [fadeInOut]
})
export class DynamicInvoiceTemplateComponent implements OnInit, OnDestroy {
  @Input() isCallFromTransactionDetail: boolean;
  @Input() CustomerId: any
  invoiceList: any = []
  dropdownVisible: any;
  invoiceData: any;
  showInvoice: any;
  @Input() invoiceId: any;
  selectedInvoiceForPayment: any;
  private invoiceRefreshSubscription: Subscription;

  constructor(
    private dynamicInvoiceTemplateService: DynamicInvoiceTemplateService,
    private modalService: NgbModal,
    private commonService: CommonService,
    private adhocInvoiceService: AdhocInvoiceService
  ) {

  }
  visibleRows: any[] = [];
  isExpanded: boolean = false;
  maxRowsToShow: number = 5;
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.getInvoiceList();

    // Subscribe to invoice refresh events from adhoc invoice generation
    this.invoiceRefreshSubscription = this.adhocInvoiceService.invoiceRefresh$.subscribe((shouldRefresh) => {
      if (shouldRefresh) {
        console.log('Invoice list refresh triggered in dynamic-invoice-template');
        this.getInvoiceList();
      }
    });
  }

  getInvoiceList(): void {
    try {
      const data = {
        CustomerId: this.CustomerId || this.getCustomerId(),
      };

      this.dynamicInvoiceTemplateService.getInvoiceList(data)
        .then((res: any) => {
          if (res.Status) {
            this.invoiceList = res.data || [];
            // Apply filter only if isCallFromTransactionDetail is true and invoiceId is defined
            if (this.isCallFromTransactionDetail && this.invoiceId) {
              this.invoiceList = this.invoiceList.filter(invoice => invoice.id === this.invoiceId);
            }
            this.updateVisibleRows(); // Update visible rows after fetching data
          } else {
            this.invoiceList = []; // Ensure the list is empty if no data
            this.updateVisibleRows(); // Clear visible rows
          }
        })
        .catch((err) => {
          console.error('Error fetching invoice list:', err);
          this.invoiceList = [];
          this.updateVisibleRows();
        });
    } catch (error) {
      console.error('Exception during fetching invoices:', error);
      this.invoiceList = [];
      this.updateVisibleRows();
    }
  }

  getCustomerId() {
    return this.CustomerId ?? sessionStorage.getItem('CustomerId');
  }
  updateVisibleRows(): void {
    if (this.invoiceList.length === 0) {
      this.visibleRows = []; // No records available
    } else {
      this.visibleRows = this.isExpanded
        ? this.invoiceList // Show all rows if expanded
        : this.invoiceList.slice(0, this.maxRowsToShow); // Show only the first 5 rows
    }
  }

  toggleView(): void {
    this.isExpanded = !this.isExpanded; // Toggle the state
    this.updateVisibleRows(); // Update the rows based on the state
  }

  viewInvoice(item) {
    try {
      const data = {
        source: item?.Source
      }
      this.dynamicInvoiceTemplateService.viewInvoice(item.id, data).then((res: any) => {
        if (res.Status) {
          this.invoiceData = res?.data
          this.showInvoice = true
          console.log('invoice data: ', this.invoiceData);
        }
      }).catch(err => {
        console.log(err)
        this.commonService.showToast('error', 'Error', err?.message);
      })
    } catch (error) {
      this.commonService.showToast('error', 'Error', error?.message);
    }
  }

  sendInvoice(item) {
    try {
      const data = {
        source: item?.Source
      }
      this.dynamicInvoiceTemplateService.sendInvoice(item.id, data).then((res: any) => {
        if (res.Status) {
          this.commonService.showToast('success', 'success', res?.message);
        }
      }).catch(err => {
        this.commonService.showToast('error', 'Error', err?.message);
      })
    } catch (error) {
      this.commonService.showToast('error', 'Error', error?.message);
    }
  }
  // updateVisibleRows(): void {
  //   if (this.isExpanded) {
  //     this.visibleRows = this.invoiceList; // Show all rows
  //   } else {
  //     this.visibleRows = this.invoiceList.slice(0, this.maxRowsToShow); // Show only the first 5 rows
  //   }
  // }

  // toggleView(): void {
  //   this.isExpanded = !this.isExpanded;
  //   this.updateVisibleRows();
  // }

  async toggleDropdown(index: number) {
    if (this.dropdownVisible.has(index)) {
      this.dropdownVisible.delete(index); // Hide if already visible
    } else {
      this.dropdownVisible.clear();
      this.dropdownVisible.add(index); // Show if not visible
    }
  }

  goBack() {
    this.showInvoice = false
  }

  /**
   * Handle payment completion from invoice detail view
   */
  handlePaymentCompleted() {
    // Refresh invoice list after successful payment
    this.getInvoiceList();
    // Go back to list view
    this.goBack();
  }

  /**
   * Check if invoice is unpaid
   */
  isUnpaid(invoice: any): boolean {
    const status = invoice?.Status?.toLowerCase();
    return status === 'unpaid' || status === 'pending' || status === 'due';
  }

  /**
   * Open payment modal for unpaid invoice
   */
  async payNow(invoice: any) {
    try {
      // Store selected invoice for payment
      this.selectedInvoiceForPayment = invoice;

      // Prepare invoice data for payment component
      const invoicePaymentData = {
        data: {
          id: invoice.id,
          customer_id: this.CustomerId,
          number: invoice.InvoiceNumber || invoice.id,
          amount: invoice.Amount,
          TotalAmount: invoice.Amount
        },
        customerData: null, // Will be populated if needed
        invoiceType: invoice.Type || 'invoice'
      };

      // Emit invoice data to payment component
      await this.adhocInvoiceService.emitInvoiceData(invoicePaymentData);

      // Open payment modal
      const modalRef = this.modalService.open(AdhocPaymentOptionsComponent, {
        size: 'lg',
        centered: true,
        backdrop: 'static',
        keyboard: false
      });

      // Handle modal close
      modalRef.result.then(
        (result) => {
          if (result === 'Payment successful') {
            this.commonService.showToast('success', 'Payment Successful', 'Invoice has been paid successfully.');
            // Refresh invoice list
            this.getInvoiceList();
          }
        },
        (reason) => {
          console.log('Payment modal dismissed:', reason);
        }
      );
    } catch (error) {
      console.error('Error opening payment modal:', error);
      this.commonService.showToast('error', 'Error', 'Failed to open payment modal.');
    }
  }

  ngOnDestroy(): void {
    // Unsubscribe to prevent memory leaks
    if (this.invoiceRefreshSubscription) {
      this.invoiceRefreshSubscription.unsubscribe();
    }
  }
}
